exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._5ulTv p{font-size:15px;color:#2f2f2f;line-height:normal;margin-bottom:30px}body.reader-night-mode ._5ulTv p{color:#b3b3b3}._5ulTv .zw-UG{font-size:14px;width:136px;border:none;height:42px;border-radius:24.5px;background-color:#00b61f;color:#fff;margin-right:30px}body.reader-night-mode ._5ulTv .zw-UG{border:none}._5ulTv ._1LsjJ{color:#929292;cursor:pointer}body.reader-night-mode ._5ulTv ._1LsjJ{color:#b3b3b3}._5ulTv ._1LsjJ:hover{color:#ccc}", ""]);

// exports
exports.locals = {
	"content": "_5ulTv",
	"btn": "zw-UG",
	"cancel": "_1LsjJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/components/HasBindMordal/HasOtherAccount.scss
// module id = Vpld
// module chunks = 8